export const CATEGORIES = {
  CROSS_SELL_PROTECTION: 'crossSellProtection',
  CROSS_SELL_ONE: 'crossSellOne',
}
